// Un solo orologio (§13): il tick condiviso sta in useClock.
import { useEffect, useState } from 'react';

let subscribers: (() => void)[] = [];
let timer: number | undefined;

function ensureTimer() {
  if (timer !== undefined) return;
  timer = window.setInterval(() => subscribers.forEach((s) => s()), 1000);
}

export function useClock(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const cb = () => setNow(Date.now());
    subscribers.push(cb);
    ensureTimer();
    return () => {
      subscribers = subscribers.filter((s) => s !== cb);
      if (subscribers.length === 0 && timer !== undefined) {
        window.clearInterval(timer);
        timer = undefined;
      }
    };
  }, []);
  return now;
}

const P = (n: number) => String(n).padStart(2, '0');

export function absolute(iso: string): string {
  const d = new Date(iso);
  return `${P(d.getDate())}/${P(d.getMonth() + 1)}/${d.getFullYear()}, ${P(d.getHours())}:${P(d.getMinutes())}:${P(d.getSeconds())}`;
}

const MONTHS = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

export function relative(iso: string, now = Date.now()): string {
  const t = new Date(iso).getTime();
  const diff = t - now;
  if (diff > 0) {
    const m = Math.round(diff / 60_000);
    if (m < 60) return 'tra ' + m + ' min';
    const h = Math.floor(m / 60);
    return 'tra ' + h + ' h ' + (m % 60) + ' min';
  }
  const s = Math.round(-diff / 1000);
  if (s < 10) return 'adesso';
  if (s < 60) return s + ' s fa';
  const m = Math.floor(s / 60);
  if (m < 60) return m + ' min fa';
  const h = Math.floor(m / 60);
  const d = new Date(t);
  const today = new Date(now);
  if (h < 24 && d.getDate() === today.getDate()) return h + ' h fa';
  const days = Math.floor(h / 24);
  if (days <= 1) return `ieri, ${P(d.getHours())}:${P(d.getMinutes())}`;
  if (days <= 7) return days + ' giorni fa';
  return `${d.getDate()} ${MONTHS[d.getMonth()]}, ${P(d.getHours())}:${P(d.getMinutes())}`;
}

export function mmss(msLeft: number): string {
  const s = Math.max(0, Math.round(msLeft / 1000));
  return P(Math.floor(s / 60)) + ':' + P(s % 60);
}

export function minutesAgo(min: number): string {
  return new Date(Date.now() - min * 60_000).toISOString();
}

export function hoursAgo(h: number): string {
  return new Date(Date.now() - h * 3_600_000).toISOString();
}
